import { useState, useEffect } from 'react';
import MainHeader from '../home/MainHeader';
import Footer from '../Footer';
import BillboardImage from '../home/components/BillboardImage';
import { CookiesMessage } from '../footer/CookiesMessage';
import { FloatingButtonGroup } from '../ui';
import { useSelector } from 'react-redux';
import { selectWhatsAppNumber, selectWhatsAppBusinessNumber } from '../../redux/selectors/application-selectors';

const UnifiedLayout = ({ children, showSearchBar = false, showBillboard = true }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const whatsappNumber = useSelector(selectWhatsAppNumber);
  const whatsappBusinessNumber = useSelector(selectWhatsAppBusinessNumber);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <div className='relative min-h-screen'>
        <div
          className={`fixed top-0 left-0 right-0 z-20 transition-all duration-300 ${
            isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
          }`}
        >
          <MainHeader isScrolled={isScrolled} />
        </div>
        {showBillboard && (
          <div className='relative w-full'>
            <BillboardImage />
          </div>
        )}
        <div className={`relative z-10 ${!showSearchBar ? 'p-4 container mx-auto' : ''}`}>
          {children}
        </div>
      </div>
      <Footer />
      <CookiesMessage />
      <FloatingButtonGroup 
        phoneNumber={whatsappNumber}
        businessPhoneNumber={whatsappBusinessNumber}
      />
    </>
  );
};

export default UnifiedLayout;
